import {Tab, Collapse} from "bootstrap";
import Main from "@/ts/base/Main";
import SiteHeader from "@/ts/base/Components/SiteHeader";

/**
 * For stuff that's small and doesn't require a lot of setting up
 */
export default class MiscComponentInitializer {
	constructor() {
		this.initTabs();
		this.initButtons();
		this.initCollapsibles();
		this.initSlideToComponents();
		this.initStickySidebar();
	}

	initButtons() {
		const buttonEls = document.querySelectorAll(".btn:not(.no-arrow), .link--arrow-right");
		buttonEls.forEach(item => {
			if (item.querySelector(".fa-angle-right") === null) {
				const span = item.querySelector("span");
				if (span !== null) {
					const icon = document.createElement("i");
					icon.classList.add("fas", "fa-angle-right");
					icon.setAttribute("aria-hidden", "true");
					span.append(icon);
				}
			}
		});
	}

	initSlideToComponents() {
		window.document.querySelectorAll("[data-action=slideTo]").forEach((el) => {
			(<HTMLElement>el).addEventListener("click", (e) => {
				e.preventDefault();
				const link = <HTMLElement>e.currentTarget;
				const target = document.querySelector(<string>link.dataset.target);
				if (target instanceof HTMLElement) {
					window.scrollTo({
						top: target.offsetTop - (Main.Instance.getHeaderComponent()?.getHeight() || 0),
						behavior: "smooth"
					});
				}
			});
		});
	}

	initTabs() {
		document.querySelectorAll('ul.tabs > li').forEach((triggerEl, index) => {
			let autoOpenIndex = -1;
			const parentEl = triggerEl.parentElement;
			const tabTrigger = new Tab(triggerEl);
			const autoOpenAttr = parentEl?.dataset.autoOpen;
			if (autoOpenAttr && autoOpenAttr.length > 0) {
				autoOpenIndex = parseInt(autoOpenAttr);
			}

			triggerEl.addEventListener('click', (event) => {
				event.preventDefault();
				tabTrigger.show();
			});

			if (autoOpenIndex > -1 && index === autoOpenIndex) {
				tabTrigger.show();
			}
		});
	}

	initCollapsibles() {

		(<NodeListOf<HTMLElement>>document.querySelectorAll("[data-toggle=collapse]"))
			.forEach(item => {
				const target = document.querySelector(<string>item.dataset.target);
				if (target) {
					const collapse = new Collapse(target, {
						toggle: false
					});
					item.addEventListener("click", (e) => {
						if (target.classList.contains("show")) {
							item.setAttribute("aria-expanded", "false");
							item.classList.add("collapsed");
						}
						else {
							item.setAttribute("aria-expanded", "true");
							item.classList.remove("collapsed");
						}
						collapse.toggle();
					});
				}
			});
	}

	initStickySidebar() {
		const sidebarEl = document.querySelector('.content-sidebar');
		if (sidebarEl instanceof HTMLElement) {
			const stickyEl = sidebarEl.querySelector('.sticky');
			if (stickyEl instanceof HTMLElement) {
				const padding = 40;
				const header = <SiteHeader>Main.Instance.getHeaderComponent();
				window.addEventListener('load', (e) => {
					stickyEl.style.top = header.getHeight() + padding + "px";
				});
				window.addEventListener('resize', (e) => {
					stickyEl.style.top = header.getHeight() + padding + "px";
				});
			}
		}
	}
}
